import { AUTH_SERVICE_FREQUENCIES } from '../constants/static-data.constants';

/**
 * Matches a stored frequency to one of the dropdown options, ignoring case and
 * punctuation, so values saved as "BIWEEKLY", "Bi Weekly" or "biweekly" all resolve.
 */
function findFrequencyOption(frequency: any) {
  if (frequency === null || frequency === undefined) {
    return undefined;
  }

  const normalized = String(frequency).replace(/[^a-z]/gi, '').toLowerCase();
  return AUTH_SERVICE_FREQUENCIES.find(
    (option) => option.value.replace(/[^a-z]/gi, '').toLowerCase() === normalized
  );
}

/** The option value to bind to the frequency dropdown, so an edit preselects correctly. */
export function normalizeServiceFrequency(frequency: any) {
  return findFrequencyOption(frequency)?.value ?? frequency ?? null;
}

/** Resolves a stored frequency to its display label, falling back to the raw value. */
export function getServiceFrequencyLabel(frequency: any): string {
  return findFrequencyOption(frequency)?.label ?? frequency ?? '';
}

/**
 * Formats a service detail price for read-only grid display. Prices carry up to three
 * decimals, so the third is kept when present rather than rounded away.
 */
export function formatServicePrice(price: any): string {
  const amount = Number(price);
  if (!Number.isFinite(amount)) {
    return '';
  }
  return `$${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 3 })}`;
}

/** Maps a service detail record into the shape the grids render. */
export function toServiceDetailRow(service: any) {
  return {
    ...service,
    frequencyLabel: getServiceFrequencyLabel(service.frequency),
    priceDisplay: formatServicePrice(service.price),
  };
}
